import { render, staticRenderFns } from "./ParamTipoRateio.vue?vue&type=template&id=76c9d4aa"
import script from "./ParamTipoRateio.vue?vue&type=script&lang=js"
export * from "./ParamTipoRateio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports